<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-music`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43.973 6.032a2 2 0 01.027.325V36a8 8 0 11-3.996-6.927L40 29.068V18.572l-20 3.304V36a8 8 0 11-3.999-6.93L16 10.323a2 2 0 011.674-1.974l24-3.964a2 2 0 012.3 1.648zM12 32.107c-2.282 0-4 1.91-4 4 0 2.091 1.718 4 4 4s4-1.909 4-4c0-2.09-1.718-4-4-4zm24 0c-2.282 0-4 1.91-4 4 0 2.091 1.718 4 4 4s4-1.909 4-4c0-2.09-1.718-4-4-4zM40 8.68l-20 3.303v5.874l20-3.304V8.68z"/></svg>
</template>
<script>

export default {
  name: 'IconMusic',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
